<template>
  <c-grid
    width="100%"
    gap="16px"
    template-columns="1fr 1fr 1fr 190px 30px"
  >
    <c-box>
      <FormSelect
        v-model="form.indicator"
        :label="`Indikator ${index + 1}`"
        :placeholder="`Pilih indikator ${index + 1}`"
        :options="indicatorOptions"
        is-required
        is-helper
        :is-invalid="isInvalidField($v.form?.indicator)"
        :invalid-text="parseErrors(`Indikator ${index + 1}`, $v.form?.indicator, customMessageErrors)"
        @blur="$v.form.indicator.$touch"
      />
      <FormInput
        v-if="form.indicator === 'Lainnya'"
        v-model="form.indicatorOther"
        type="text"
        :label="`Indicator Lainnya ${index + 1}`"
        placeholder="Masukkan indikator lainnya"
        is-required
        is-helper
        helper-text-color="#888"
        helper-text-type="info"
        helper-text="Maksimal 20 karakter"
        :is-invalid="isInvalidField($v.form?.indicatorOther)"
        :invalid-text="parseErrors(`Indikator Lainnya`, $v.form?.indicatorOther, customMessageErrors)"
        is-without-label
        @blur="$v.form.indicatorOther.$touch"
      />
    </c-box>
    <c-box>
      <c-text
        :font-size="['14px', '16px']"
        font-weight="400"
        font-family="Roboto"
        padding="0px 12px 4px 0px"
        :color="!form.indicator ? '#888' : (isInvalidField($v.form?.currentCondition) || isInvalidField($v.form?.currentConditionUnit) ? '#D32737' : (form.currentCondition && form.currentConditionUnit ? '#008C81' : '#555'))"
      >
        Kondisi Saat ini {{ index + 1 }} 
        <c-box
          as="span"
          color="#D32737"
        >
          *
        </c-box>
      </c-text>
      <c-flex>
        <FormInput
          v-model="form.currentCondition"
          v-chakra="{
            'input': {
              borderTopRightRadius: '0px !important',
              borderBottomRightRadius: '0px !important',
            }
          }"
          type="text"
          :label="`Kondisi Saat ini ${index + 1}`"
          placeholder="Masukkan kondisi saat ini"
          is-required
          :is-invalid="form.indicator ? isInvalidField($v.form?.currentCondition) : false"
          :invalid-text="parseErrors(`Kondisi Saat ini ${index + 1}`, $v.form?.currentCondition, customMessageErrors)"
          :is-disabled="!form.indicator"
          is-without-label
          flex-grow="1"
          @blur="$v.form.currentCondition.$touch"
        />
        <c-box
          flex-shrink="0"
          :width="form.currentConditionUnit ? `calc(${form.currentConditionUnit?.length || 3}ch + ${isAutomaticConclusion ? '5ch' : '7ch'})` : '150px'"
          min-width="64px"
          max-width="240px"
          transition="all 150ms ease-in-out"
        >
          <FormInput
            v-if="isAutomaticConclusion"
            v-model="form.currentConditionUnit"
            v-chakra="{
              'input': {
                borderTopLeftRadius: '0px !important',
                borderBottomLeftRadius: '0px !important',
                backgroundColor: '#F2F2F2 !important',
                color: '#008C81 !important',
                textAlign: 'center',
              }
            }"
            type="text"
            label=""
            placeholder="Satuan"
            is-required
            is-read-only
            :is-invalid="form.indicator ? isInvalidField($v.form?.currentConditionUnit) : false"
            :invalid-text="parseErrors('Lainnya', $v.form?.currentConditionUnit, customMessageErrors)"
            is-without-label
            @blur="$v.form.currentConditionUnit.$touch"
          />
          <FormSelect
            v-else
            v-model="form.currentConditionUnit"
            v-chakra="{
              'select': {
                borderTopLeftRadius: '0px !important',
                borderBottomLeftRadius: '0px !important',
                backgroundColor: '#F2F2F2',
              }
            }"
            label=""
            :placeholder="`Pilih satuan`"
            :options="currentConditionOptions"
            is-required
            :is-invalid="form.indicator ? isInvalidField($v.form?.currentConditionUnit) : false"
            :invalid-text="parseErrors('Satuan', $v.form?.currentConditionUnit, customMessageErrors)"
            :is-disabled="!form.indicator"
            is-without-label
            @blur="$v.form.currentConditionUnit.$touch"
          />
        </c-box>
      </c-flex>
      <FormInput
        v-if="form.currentConditionUnit === 'Lainnya' && form.indicator"
        v-model="form.currentConditionUnitOther"
        type="text"
        :label="`Kondisi Saat ini ${index + 1}`"
        placeholder="Masukkan lainnya"
        is-required
        is-helper
        helper-text-color="#888"
        helper-text-type="info"
        helper-text="Maksimal 20 karakter"
        :is-invalid="isInvalidField($v.form?.currentConditionUnitOther)"
        :invalid-text="parseErrors('Lainnya', $v.form?.currentConditionUnitOther, customMessageErrors)"
        is-without-label
        @blur="$v.form.currentConditionUnitOther.$touch"
      />
    </c-box>

    <c-box>
      <c-text
        :font-size="['14px', '16px']"
        font-weight="400"
        font-family="Roboto"
        padding="0px 12px 4px 0px"
        :color="!form.indicator ? '#888' :(isInvalidField($v.form?.standardValue) || isInvalidField($v.form?.standardValueUnit) ? '#D32737' : (form.standardValue && form.standardValueUnit ? '#008C81' : '#555'))"
      >
        Nilai Standard {{ index + 1 }} 
        <c-box
          as="span"
          color="#D32737"
        >
          *
        </c-box>
      </c-text>
      <c-flex>
        <FormInput
          v-model="form.standardValue"
          v-chakra="{
            'input': {
              borderTopRightRadius: '0px !important',
              borderBottomRightRadius: '0px !important',
            }
          }"
          type="text"
          :label="`Nilai Standard ${index + 1}`"
          placeholder="Masukkan nilai standard"
          is-required
          :is-invalid="form.indicator ? isInvalidField($v.form?.standardValue) : false"
          :invalid-text="parseErrors(`Nilai Standard ${index + 1}`, $v.form?.standardValue, customMessageErrors)"
          :is-disabled="!form.indicator || isAutomaticConclusion"
          :is-read-only="isAutomaticConclusion"
          is-without-label
          flex-grow="1"
          @blur="$v.form.standardValue.$touch"
        />
        <c-box
          flex-shrink="0"
          :width="form.standardValueUnit ? `calc(${form.standardValueUnit?.length || 3}ch + ${isAutomaticConclusion ? '5ch' : '7ch'})` : '150px'"
          min-width="64px"
          max-width="240px"
          transition="all 150ms ease-in-out"
        >
          <FormInput
            v-if="isAutomaticConclusion"
            v-model="form.standardValueUnit"
            v-chakra="{
              'input': {
                borderTopLeftRadius: '0px !important',
                borderBottomLeftRadius: '0px !important',
                backgroundColor: '#F2F2F2 !important',
                color: '#008C81 !important',
                textAlign: 'center',
              }
            }"
            type="text"
            label=""
            placeholder="Satuan"
            is-required
            is-read-only
            :is-invalid="form.indicator ? isInvalidField($v.form?.standardValueUnit) : false"
            :invalid-text="parseErrors('Lainnya', $v.form?.standardValueUnit, customMessageErrors)"
            is-without-label
            @blur="$v.form.standardValueUnit.$touch"
          />
          <FormSelect
            v-else
            v-model="form.standardValueUnit"
            v-chakra="{
              'select': {
                borderTopLeftRadius: '0px !important',
                borderBottomLeftRadius: '0px !important',
                backgroundColor: '#F2F2F2',
              }
            }"
            label=""
            :placeholder="`Pilih satuan`"
            :options="standardValueOptions"
            is-required
            :is-invalid="form.indicator ? isInvalidField($v.form?.standardValueUnit) : false"
            :invalid-text="parseErrors('Satuan', $v.form?.standardValueUnit, customMessageErrors)"
            :is-disabled="!form.indicator"
            is-without-label
            @blur="$v.form.standardValueUnit.$touch"
          />
        </c-box>
      </c-flex>
      <FormInput
        v-if="form.standardValueUnit === 'Lainnya' && form.indicator"
        v-model="form.standardValueUnitOther"
        type="text"
        :label="`Nilai Standard ini ${index + 1}`"
        placeholder="Masukkan lainnya"
        is-required
        is-helper
        helper-text-color="#888"
        helper-text-type="info"
        helper-text="Maksimal 20 karakter"
        :is-invalid="isInvalidField($v.form?.standardValueUnitOther)"
        :invalid-text="parseErrors(`Lainnya`, $v.form?.standardValueUnitOther, customMessageErrors)"
        is-without-label
        @blur="$v.form.standardValueUnitOther.$touch"
      />
    </c-box>

    <c-box>
      <StatusLabel
        v-if="isAutomaticConclusion"
        :label="`Kesimpulan ${index + 1}`"
        :value="form.conclusion ?? '-'"
        color="green"
        width="100%"
        :text-color="form.statusLabel?.color"
        :background-color="form.statusLabel?.background"
      />
      <c-box
        v-else
      >
        <FormSelect
          v-model="form.conclusion"
          :label="`Kesimpulan ${index + 1}`"
          :placeholder="`Pilih kesimpulan ${index + 1}`"
          :options="conclusionOptions"
          is-required
          :is-invalid="form.indicator ? isInvalidField($v.form?.conclusion) : false"
          :invalid-text="parseErrors(`Kesimpulan ${index + 1}`, $v.form?.conclusion, customMessageErrors)"
          :is-disabled="!form.indicator"
          @blur="$v.form.conclusion.$touch"
        />
        <FormInput
          v-if="form.conclusion === 'Lainnya' && form.indicator"
          v-model="form.conclusionOther"
          type="text"
          :label="`Kesimpulan Lainnya ${index + 1}`"
          placeholder="Masukkan kesimpulan lainnya"
          is-required
          is-helper
          helper-text-color="#888"
          helper-text-type="info"
          helper-text="Maksimal 20 karakter"
          :is-invalid="isInvalidField($v.form?.conclusionOther)"
          :invalid-text="parseErrors(`Kesimpulan Lainnya`, $v.form?.conclusionOther, customMessageErrors)"
          is-without-label
          @blur="$v.form.conclusionOther.$touch"
        />
      </c-box>
    </c-box>
    <c-box
      v-if="index > 1"
      flex-shrink="0"
    >
      <c-button
        min-width="30px"
        width="30px"
        height="30px"
        margin-top="42px"
        padding="6px"
        background-color="transparent"
        @click="$emit('remove')"
      >
        <inline-svg
          :src="require('@/assets/icons/icon-trash.svg')"
          height="24px"
          width="24px"
          fill="#D32737"
        />
      </c-button>
    </c-box>
  </c-grid>
</template>

<script>
import { required, requiredIf, maxLength } from 'vuelidate/lib/validators'
import { isInvalidField } from '@/utils/vuelidate-helpers/is-invalid-field'
import { parseErrors } from '@/utils/vuelidate-helpers/parse-errors'
import FormSelect from '@/views/client/kuisioner/forms/form-select-2'
import FormInput from '@/views/client/kuisioner/forms/form-input-2'
import StatusLabel from '@/components/meal-plan/_widgets/status-label.vue'
import { bodyConditionFormula } from '@/utils/meal-plans'
import { maternalConditionOptions } from '@/constants/meal-plans'

export default {
  components: {
    FormSelect,
    FormInput,
    StatusLabel,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          indicator: null,
          indicatorOther: null,
          currentCondition: null,
          currentConditionUnit: null,
          currentConditionUnitOther: null,
          standardValue: null,
          standardValueUnit: null,
          standardValueUnitOther: null,
          conclusion: null,
          conclusionOther: null,
          statusLabel: {
            color: null,
            background: null,
          },
        }
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    currentConditionOptions: {
      type: Array,
      default: () => [],
    },
    standardValueOptions: {
      type: Array,
      default: () => [],
    },
    conclusionOptions: {
      type: Array,
      default: () => [],
    },
    indicatorOptions: {
      type: Array,
      default: () => [],
    },
    nutritionalConditions: {
      type: [Object, null],
      default: null,
    },
    nutritionalIntake: {
      type: [Object, null],
      default: null,
    },
  },
  emits: ['input', 'remove'],
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    customMessageErrors() {
      return {
        required: '{{fieldName}} wajib diisi',
        maxLength: '{{fieldName}} melebihi {{maxLength.max}} karakter',
      }
    },
    constants() {
      return {
        maternalConditionOptions,
      }
    },
    calculationType() {
      return this.nutritionalConditions?.calculationType || null
    },
    isAutomaticConclusion() {
      if (!this.form.indicator) return false

      const selectedIndicator = this.indicatorOptions.find((item) => item?.value.toLowerCase() === this.form.indicator.toLowerCase())

      if (!selectedIndicator) return false
      
      return selectedIndicator?.ageGroup.some((it) => it === this.calculationType)
    },
  },
  watch: {
    form: {
      handler(val) {
        const indicator = val.indicator?.toLowerCase()
        if (indicator) {
          const INDIKATOR_LEVELS = this.indicatorOptions.find((item) => indicator === item?.value?.toLowerCase())?.data
          if (this.calculationType === 'adult') {
            switch (indicator) {
              case 'asupan cairan': {
                const maternalCondition = Number(this.nutritionalConditions[this.nutritionalConditions?.formula]?.maternalCondition) || 0
                const isPregnant = maternalCondition !== 0
                const result = bodyConditionFormula.checkWaterIntake(
                  parseFloat(this.form.currentCondition || 0),
                  parseFloat(this.nutritionalConditions?.age?.years || 0),
                  this.nutritionalConditions?.gender,
                  isPregnant,
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'aktivitas fisik': {
                const result = bodyConditionFormula.checkPhysicalActivity(
                  parseFloat(this.form.currentCondition || 0),
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'lingkar pinggang': {
                const result = bodyConditionFormula.checkWaistCircumference(
                  parseFloat(this.form.currentCondition || 0),
                  this.nutritionalConditions?.gender,
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'gula darah sewaktu': {
                const result = bodyConditionFormula.checkRandomBloodSugar(
                  parseFloat(this.form.currentCondition || 0),
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'gula darah puasa':{
                const result = bodyConditionFormula.checkFastingBloodSugar(
                  parseFloat(this.form.currentCondition || 0),
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'ldl': {
                const result = bodyConditionFormula.checkLDL(
                  parseFloat(this.form.currentCondition || 0),
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'hdl': {
                const result = bodyConditionFormula.checkHDL(
                  parseFloat(this.form.currentCondition || 0),
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'total kolesterol': {
                const result = bodyConditionFormula.checkTotalCholesterol(
                  parseFloat(this.form.currentCondition || 0),
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'asam urat': {
                const result = bodyConditionFormula.checkUricAcid(
                  parseFloat(this.form.currentCondition || 0),
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'hba1c': {
                const result = bodyConditionFormula.checkHbA1C(
                  parseFloat(this.form.currentCondition || 0),
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'hb': {
                const maternalCondition = Number(this.nutritionalConditions[this.nutritionalConditions?.formula]?.maternalCondition) || 0
                const maternalConditionLabel = this.nutritionalConditions[this.nutritionalConditions?.formula]?.maternalConditionLabel
                const trimester = maternalCondition > 0 && maternalCondition < 301 ?
                  (this.constants.maternalConditionOptions.find((item) => item.label === maternalConditionLabel)?.label || null) : null
                const result = bodyConditionFormula.checkHbLevel(
                  parseFloat(this.form.currentCondition || 0),
                  parseFloat(this.nutritionalConditions?.age.years || 0),
                  this.nutritionalConditions?.gender,
                  trimester,
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
              }
            }  
          } else if (this.calculationType === 'child') {
            switch(indicator) {
              case 'asupan cairan': {
                const isPregnant = false
                const result = bodyConditionFormula.checkWaterIntake(
                  parseFloat(this.form.currentCondition || 0),
                  parseFloat(this.nutritionalConditions?.age?.totalMonths / 12 || 0),
                  this.nutritionalConditions?.gender,
                  isPregnant,
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
              case 'hb': {
                const pregnantTrimester = null
                const result = bodyConditionFormula.checkHbLevel(
                  parseFloat(this.form.currentCondition || 0),
                  parseFloat(this.nutritionalConditions?.age?.totalMonths / 12 || 0),
                  this.nutritionalConditions?.gender,
                  pregnantTrimester,
                  INDIKATOR_LEVELS,
                )
                this.form.conclusion = result.status
                this.form.standardValue = result.requirement
                this.form.currentConditionUnit = result?.unit
                this.form.standardValueUnit = result?.unit
                break
              }
            }
          }
        }
        
        const getColor = bodyConditionFormula.getStatusColor(this.form.conclusion)
        this.form.statusLabel.color = getColor?.color
        this.form.statusLabel.background = getColor?.background
      },
      deep: true,
    },
    isAutomaticConclusion: {
      handler(val) {
        if (!val) {
          this.form.standardValue = null
          this.form.standardValueUnit = null
          this.form.currentConditionUnit = null
          this.form.conclusion = null
          this.form.conclusionOther = null
        }
      },
    },
  },
  validations: {
    form: {
      indicator: {
        required,
      },
      indicatorOther: {
        required: requiredIf((model) => model.indicator === 'Lainnya'),
        maxLength: maxLength(20),
      },
      currentCondition: {
        required,
      },
      currentConditionUnit: {
        required,
      },
      currentConditionUnitOther: {
        required: requiredIf((model) => model.currentConditionUnit === 'Lainnya'),
        maxLength: maxLength(20),
      },
      standardValue: {
        required,
      },
      standardValueUnit: {
        required,
      },
      standardValueUnitOther: {
        required: requiredIf((model) => model.standardValueUnit === 'Lainnya'),
        maxLength: maxLength(20),
      },
      conclusion: {
        required,
      },
      conclusionOther: {
        required: requiredIf((model) => model.conclusion === 'Lainnya'),
        maxLength: maxLength(20),
      },
    },
  },
  methods: {
    isInvalidField,
    parseErrors,
    onFormTouch() {
      this.$v.form.indicator.$touch()
      this.$v.form.currentCondition.$touch()
      this.$v.form.currentConditionUnit.$touch()
      this.$v.form.standardValue.$touch()
      this.$v.form.standardValueUnit.$touch()
      this.$v.form.currentCondition.$touch()
      this.$v.form.conclusion.$touch()

      if (this.form.indicator === 'Lainnya') {
        this.$v.form.indicatorOther.$touch()
      }

      if (this.form.currentConditionUnit === 'Lainnya') {
        this.$v.form.currentConditionUnitOther.$touch()
      }

      if (this.form.standardValueUnit === 'Lainnya') {
        this.$v.form.standardValueUnitOther.$touch()
      }

      if (this.form.conclusion === 'Lainnya') {
        this.$v.form.conclusionOther.$touch()
      }
    },
  },
}
</script>

<style>

</style>